// src/pages/ModuleLanding.jsx
import React from "react";
import { useParams } from "react-router-dom";

export default function ModuleLanding() {
  const { moduleId } = useParams();

  const moduleTitle =
    moduleId === "1" ? "ZEDRO Core" :
    moduleId === "2" ? "ZEDRO Systems" :
    moduleId === "3" ? "ZEDRO Assets" :
    moduleId === "4" ? "ZEDRO Cultura" : "Módulo";

  return (
    <main
      style={{
        padding: "2rem 1rem",
        minHeight: "70vh",
        fontFamily: "Questrial, sans-serif",
        background: "#f7f9fb",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h1 style={{ color: "#264763", fontFamily: "Bitter, serif" }}>
          {moduleTitle}
        </h1>

        <p style={{ marginTop: "1rem", color: "#4b5a6a" }}>
          Este módulo estará disponible próximamente.
        </p>
      </div>
    </main>
  );
}